// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ko8c","row":"Node_row__a156O","label":"Node_label__2VvWP","footer":"Node_footer__gjfR6"};